import Head from 'next/head';
import PropTypes from 'prop-types';

import BlogPostsListPage from '@/components/BlogPostsListPage/BlogPostsListPage';
import PageBreadcrumbs from '@/components/PageBreadcrumbs/PageBreadcrumbs';
import blogConfig from '@/configs/blog';
import strapiApi from '@/helpers/strapi/api';
import useFormatMessage from '@/hooks/useFormatMessage';
import DefaultLayout from '@/layouts/default';

const PAGE_TITLE =
  'klickrent Blog: Baubranchen Einblicke und Baustellen Trends';
const PAGE_DESCRIPTION =
  'Einblicke von klickrent in die Baubranche. Erhalten Sie Informationen und Trends rund um die Bauindustrie, Baustellen und den Einsatz von Baumaschinen.';

const BlogPost = ({ page, categories }) => {
  const formatMessage = useFormatMessage();

  return (
    <>
      <Head>
        <title>{PAGE_TITLE}</title>
        <meta key="description" name="description" content={PAGE_DESCRIPTION} />
        <meta property="og:title" content={PAGE_TITLE} key="og:title" />
        <meta
          property="og:description"
          content={PAGE_DESCRIPTION}
          key="og:description"
        />
      </Head>
      <PageBreadcrumbs
        breadcrumbs={[
          {
            id: 1,
            title: formatMessage('breadcrumbs_home'),
            metadata: {
              id: 1,
              pathname: '/',
            },
          },
          {
            id: 2,
            title: formatMessage('blog_breadcrumb'),
            metadata: {
              id: 2,
              pathname: `${blogConfig.homepage}`,
            },
          },
        ]}
      />
      <BlogPostsListPage pageData={page} categories={categories} />
    </>
  );
};

BlogPost.getLayout = function getLayout(page) {
  return <DefaultLayout>{page}</DefaultLayout>;
};

BlogPost.propTypes = {
  page: PropTypes.object,
};

BlogPost.defaultProps = {
  page: undefined,
};

export async function getServerSideProps({ query, resolvedUrl }) {
  const { page, category } = query;
  const [pathname, queryParams] = resolvedUrl.split('?');

  const sanitizedCategory =
    `/${category}` !== blogConfig.allCategoryPathname ? `/${category}` : '';
  const { data: pageData } = await strapiApi.getBlogPostsByCategoryPathname(
    sanitizedCategory,
    page
  );

  if (!pageData) {
    return { notFound: true };
  }

  if (pageData.meta.pagination.page > pageData.meta.pagination.pageCount) {
    return { notFound: true };
  }

  const decodedPathname = decodeURI(pathname);
  if (decodedPathname !== decodedPathname.toLowerCase()) {
    const destination = [encodeURI(decodedPathname.toLowerCase()), queryParams]
      .filter(Boolean)
      .join('?');

    return {
      redirect: {
        destination,
        permanent: true,
      },
    };
  }

  const {
    data: { data: categories },
  } = await strapiApi.getBlogCategories();

  return {
    props: {
      page: pageData,
      categories,
    },
  };
}

export default BlogPost;
